function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as types from './types';
export var initialState = {
  isConnected: true
};
export default function connection(state, _ref) {
  if (state === void 0) {
    state = initialState;
  }

  var payload = _ref.payload,
      type = _ref.type;

  switch (type) {
    case types.ON_CONNECTION_STATE_CHANGED:
      return _extends({}, state, payload);

    default:
      return state;
  }
}